// Case Studies page entry point

import { initSwiperCaseStudiesWithResize } from './swiper-case-studies.js';

// ─── Swipers ──────────────────────────────────────────────────────────────────

initSwiperCaseStudiesWithResize();

// Finsweet "Load More" scroll recompute now lives in global.js so every
// page using fs-list-element="list" gets it for free.
